// extracted by mini-css-extract-plugin
export default {"container":"style_container__V409c","companyList":"style_companyList__ko9E-"};